<template>
<el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <el-drawer title="新建运单" @close="closeDialog"  direction="ltr" size="50%"  :visible="addFlag">
      <div style="padding:12px" class="inpBox">
        <el-form-item label="运单状态:" prop="wayState"  v-if="goodform.WHJKflag==1">
           <span>待装车</span>
        </el-form-item>
        <el-form-item label="运单状态:" prop="wayState"  v-else>
          <el-radio-group v-model="goodform.wayState"   @change="wayStateChange"  >
            <el-radio :label="1">待装车</el-radio>
            <el-radio :label="2">运输中</el-radio>
            <el-radio :label="3">待签收</el-radio>
            <el-radio :label="4">已签收</el-radio>
          </el-radio-group>
        </el-form-item>
        <br>
        <el-form-item label="结算客户 :" prop="payee" >
          <el-select v-model="goodform.payee" filterable placeholder="请选择" @change="jiesuanChange">
            <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称:" prop="projectType"   >
          <el-select  v-model="goodform.projectType" filterable placeholder="请选择">
            <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型:" prop="wayBusinessType"   >
          <el-select  v-model="goodform.wayBusinessType"  placeholder="请选择">
            <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售合同:"  >
          <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.salesContract"  ></el-input>
        </el-form-item>
        <el-button type="text"  @click="xuanzeHT" style="margin-top: 8px;">选择</el-button>
        <el-form-item label="外部单号:"  >
          <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
        </el-form-item>
        <el-form-item label="业务部门:" prop="insuranceInfo"   >
          <el-select v-if="oldWayId" v-model="goodform.businessUnitCode" filterable placeholder="请选择" @change="bumenChange">
            <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
          <div v-else style="width:150px">{{goodform.businessUnit}}</div>
        </el-form-item>
        <el-form-item label="业务人员:" prop="businessUserId">
          <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
          <el-select v-else v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
            <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <hr>
        <!-- 地址组件 -->
        <addDizhi :goodform="goodform" v-if="addFlag" ></addDizhi>
        <hr>
        <!-- 添加货物外库 -->
        <addGoodWay :goodform="goodform" v-if="addFlag" :glhwFlag="glhwFlag"></addGoodWay>
        <div class="addressBox" style="margin-top:20px">
         <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>运输要求</span>
          </h4>
          <el-form-item label="要求到达时间:" prop="arrivalTime" label-width="120px">
              <el-date-picker
                v-model="goodform.arrivalTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
                type="datetime"
                placeholder="选择日期时间"
                :picker-options="pickerOptions"
              ></el-date-picker>
          </el-form-item>
          <el-form-item label="回单要求:" prop="receiptRequest"   >
            <el-select  v-model="goodform.receiptRequest"  placeholder="请选择">
              <el-option  label="纸质回单" value="纸质回单" ></el-option>
              <el-option  label="电子回单" value="电子回单" ></el-option>
              <el-option  label="否" value="否" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="需求车长:"   >
          <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
            <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
          <br>
          <el-form-item label="提货到场时间:" label-width="120px">
              <el-date-picker
                v-model="goodform.pickupTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="提货紧急程度:" label-width="120px">
            <el-radio-group v-model="goodform.urgencyFlag"    >
              <el-radio :label="0">正常</el-radio>
              <el-radio :label="1">紧急</el-radio>
              <el-radio :label="2">加急</el-radio>
            </el-radio-group>
          </el-form-item>
          <br>
          <div>
            <el-tag style="margin:10px 10px;cursor: pointer;" v-for="item in elTags"
              :key="item"   @click="tagClick(item)" effect="plain">
              {{ item}}
            </el-tag>
          </div>
          <el-form-item label="" class="remark" prop="remark" label-width="0px">
            <el-input  placeholder="" :rows="2"  maxlength="500" v-model="goodform.remark"></el-input>
          </el-form-item>
        </div>
        <shouruWay :goodform="goodform"></shouruWay>
        <hr>
        <uploadFiles :fileArr.sync='fileArr' :max=10></uploadFiles>
      </div>
      <el-drawer title="配载" size="98%" @close="closeDialog"   class="rightDrawer"
      :modal-append-to-body="false" :modal="false"  :visible="addFlag">
        <div  style="padding:12px">
           <!-- 车辆信息组件 -->
          <cheliangxinxi :goodform="goodform" :isPaidui="true"></cheliangxinxi>
          <zhichu2 :goodform="goodform" v-if="addFlag" ></zhichu2>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div class="addressBox" v-if="goodform.wayState>=2">
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>装车</span>
          </h4>
          <el-form-item label="装车量:"  prop="truckload" class="danweiBox width1" >
            <el-input  placeholder="" v-number-input.float="3"   maxlength="8"  v-model="goodform.truckload" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
            <el-input  placeholder="" v-number-input.float="0"   maxlength="8"  v-model="goodform.truckload" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
            <el-select  v-model="goodform.measuringUnit"  placeholder=""  >
              <el-option  label="吨" value="吨" ></el-option>
              <el-option  label="件" value="件" ></el-option>
              <el-option  label="方" value="方" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="装车时间:" prop="actualLoadingTime">
                <el-date-picker  v-model="goodform.actualLoadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                  type="datetime"></el-date-picker>
          </el-form-item>
          <uploadImgs :imgList.sync='ZCimgList' :max=10></uploadImgs>
        </div>
        <div class="addressBox" v-if="goodform.wayState>=3">
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>卸车</span>
          </h4>
          <el-form-item label="卸车量:"  prop="unloadings" class="danweiBox width1">
            <el-input  placeholder="" v-number-input.float="3"   maxlength="8"  v-model="goodform.unloadings" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
            <el-input  placeholder="" v-number-input.float="0"   maxlength="8"  v-model="goodform.unloadings" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
            <!-- <span style="width:60px">{{goodform.measuringUnit}}吨</span> -->
            <el-select  v-model="goodform.measuringUnit"  placeholder="" >
              <el-option  label="吨" value="吨" ></el-option>
              <el-option  label="件" value="件" ></el-option>
              <el-option  label="方" value="方" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卸车时间:" prop="actualUnloadingTime">
                <el-date-picker  v-model="goodform.actualUnloadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                  type="datetime"  @change="actualUnloadingTimeFn"></el-date-picker>
          </el-form-item>
          <div style="margin:0 0 10px 15px ;font-size: 14px;">*回单</div>
          <uploadImgs :imgList.sync='XCimgList' :max=10></uploadImgs>
        </div>
        <div class="addressBox" v-if="goodform.wayState>=4">
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>签收</span>
          </h4>
          <el-form-item label="签收状态:" prop="signedState"  class="width1" >
            <el-select  v-model="goodform.signedState"  placeholder="请选择">
              <el-option  label="正常签收" :value="0" ></el-option>
              <el-option  label="异常签收" :value="1" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  >
            <el-input  placeholder="备注"    maxlength="50" v-model="goodform.signRemark"  ></el-input>
          </el-form-item>
          <el-form-item label="结算量:"  prop="liquidatedAmount" class="danweiBox width1" >
            <el-input  placeholder="" v-number-input.float="3"   maxlength="8" :readonly="goodform.wayState==4"  v-model="goodform.liquidatedAmount" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
            <el-input  placeholder="" v-number-input.float="0"   maxlength="8" :readonly="goodform.wayState==4" v-model="goodform.liquidatedAmount" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
            <!-- <span style="width:60px">{{goodform.measuringUnit}}吨</span> -->
            <el-select  v-model="goodform.measuringUnit"     placeholder="" >
              <el-option  label="吨" value="吨" ></el-option>
              <el-option  label="件" value="件" ></el-option>
              <el-option  label="方" value="方" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签收时间:" prop="actualSigningTime">
                <el-date-picker  v-model="goodform.actualSigningTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                  type="datetime" @change="actualSigningTimeFn"></el-date-picker>
          </el-form-item>
          <uploadImgs :imgList.sync='QSimgList' :max=10></uploadImgs>
        </div>
        <div class="footerBtn">
          <el-button  @click="closeDialog"  >取消</el-button>
          <el-button  type="primary"  @click="saveFn(1)">提 交</el-button>
          <el-button type="primary" v-if="!oldWayId" @click="saveFn(2)">复制新建</el-button>
          <el-button  type="primary"  @click="saveFn(3)">提交并打印</el-button>
        </div>
        </div>
      </el-drawer>
  </el-drawer>
  <!-- 关联合同 -->
  <guanlianhetong :goodform="goodform" v-if="GLHTflag" :GLHTflag.sync='GLHTflag'></guanlianhetong>
</el-form>
</template>

<script>
import cheliangxinxi from '@/views/newTMS/publicFiles/wayAndOrder/cheliangxinxi.vue'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhi.vue'
import addGoodWay from '@/views/newTMS/publicFiles/wayAndOrder/addGoodWay.vue'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import guanlianhetong from '@/views/newTMS/publicFiles/wayAndOrder/guanlianhetong.vue'
import zhichu2 from '@/views/newTMS/publicFiles/wayAndOrder/zhichu2.vue'
import shouruWay from '@/views/newTMS/publicFiles/wayAndOrder/shouruWay.vue'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import { getDictionaryDetailList, findCustomerInfoList, addWay, getWaynfo, pushWayToWHPTFlag } from '@/api/newTMS'
import { selectTMSTenantListByCustom, getDepartmentUsers, getCurrUserDepartment } from '@/api/newCrm'
import { cVLlist } from '@/api/vgs-driver2.0'
import { compressImages } from '@/utils/compressImages'
export default {
  name: 'addEditWay',
  components: {
    cheliangxinxi, zhichu2, addDizhi, addGoodWay, uploadFiles, guanlianhetong, shouruWay, uploadImgs
  },
  props: {
    addFlag: {
      type: Boolean,
      default: false
    },
    glhwFlag: {
      type: Boolean,
      default: false
    },
    wayBusinessId: {
      type: Number,
      default: null
    },
    oldWayId: {
      type: [Number, Array],
      default: null
    }
  },
  data () {
    return {
      goodform: {
        goodsList: [],
        measuringUnit: '吨',
        wayState: 1,

        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0',
        urgencyFlag: 0
      },
      ZCimgList: [],
      XCimgList: [],
      QSimgList: [],
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        wayState: [
          { required: true, message: '请选择运单状态', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        wayBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        allWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        truckload: [
          { required: true, message: '请输入装车量', trigger: 'blur' }
        ],
        unloadings: [
          { required: true, message: '请输入卸车量', trigger: 'blur' }
        ],
        liquidatedAmount: [
          { required: true, message: '请输入结算量', trigger: 'blur' }
        ],
        actualLoadingTime: [
          { required: true, message: '请选择装车时间', trigger: 'blur' }
        ],
        actualUnloadingTime: [
          { required: true, message: '请选择卸车时间', trigger: 'blur' }
        ],
        actualSigningTime: [
          { required: true, message: '请选择签收时间', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        taxRate: [
          { required: true, message: '请输入收入税率', trigger: 'blur' }
        ]
      },
      kehuList: [], // 结算客户
      YWLXlist: [], // 业务类型
      fileArr: [],
      GLHTflag: false, // 关联合同
      yonghuList: [],
      bumenList: [], // 业务部门列表（往返）
      ywyhFlag: false, // 客户身上是否有业务用户
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      elTags: ['需要架子', '需要棉被'],
      tagArr: [],
      CClist: [],
      XMlist: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })

    cVLlist().then(res => { this.CClist = res })
    if (this.wayBusinessId) { // 列表复制按钮跳转过来
      getWaynfo({ wayBusinessId: this.wayBusinessId }).then(res => {
        if (this.oldWayId) { // 证明往返过来的
          // 业务部门下拉列表
          getCurrUserDepartment({ compayCode: localStorage.getItem('companyCode'), isQueryDept: 0 }).then(res1 => { this.bumenList = res1 })
          // 司机车辆信息赋值
          this.$set(this.goodform, 'plateNumber', res.tWay.plateNumber)
          this.$set(this.goodform, 'licensePlateColor', res.tWay.licensePlateColor)
          this.$set(this.goodform, 'licensePlateColorName', res.tWay.licensePlateColorName)
          this.$set(this.goodform, 'vehicleId', res.tWay.vehicleId)
          this.$set(this.goodform, 'vehicleType', res.tWay.vehicleType)
          this.$set(this.goodform, 'vehicleTypeName', res.tWay.vehicleTypeName)
          this.$set(this.goodform, 'energyType', res.tWay.energyType)
          this.$set(this.goodform, 'energyTypeName', res.tWay.energyTypeName)
          this.$set(this.goodform, 'vehicleOwnership', res.tWay.vehicleOwnership)
          this.$set(this.goodform, 'vehicleOwnershipName', res.tWay.vehicleOwnershipName)
          this.$set(this.goodform, 'vehicleLength', res.tWay.vehicleLength)
          this.$set(this.goodform, 'driverId', res.tWay.driverId)
          this.$set(this.goodform, 'driverName', res.tWay.driverName)
          this.$set(this.goodform, 'driverPhone', res.tWay.driverPhone)
          this.$set(this.goodform, 'idNumber', res.tWay.idNumber)
          this.$set(this.goodform, 'driverOwnership', res.tWay.driverOwnership)
          this.$set(this.goodform, 'driverOwnershipName', res.tWay.driverOwnershipName)
          this.$set(this.goodform, 'transportMode', 1)
          this.$set(this.goodform, 'teamOrgId', res.tWay.teamOrgId)
          this.$set(this.goodform, 'teamOrgCode', res.tWay.teamOrgCode)
          this.$set(this.goodform, 'teamOrgName', res.tWay.teamOrgName)
          this.$set(this.goodform, 'companyOrgId', res.tWay.companyOrgId)
          this.$set(this.goodform, 'companyOrgCode', res.tWay.companyOrgCode)
          this.$set(this.goodform, 'companyOrgName', res.tWay.companyOrgName)

          this.$set(this.goodform, 'taxRate', 9)
          this.$set(this.goodform, 'oldWayIds', this.oldWayId)
          this.$set(this.goodform, 'wayState', 3)
          findCustomerInfoList({ businessType: 1 }).then(res => {
            selectTMSTenantListByCustom(res).then(res1 => { this.kehuList = res1 })
          })
          this.$set(this.goodform, 'businessUnit', localStorage.getItem('orgName'))
          this.$set(this.goodform, 'businessUnitCode', localStorage.getItem('orgCode'))
          this.$set(this.goodform, 'businessSubunit', localStorage.getItem('orgSubName'))
          this.$set(this.goodform, 'businessSubunitCode', localStorage.getItem('orgSubCode'))
          this.$set(this.goodform, 'businessTenantCode', localStorage.getItem('tenantCode'))
          this.$set(this.goodform, 'businessTenantName', localStorage.getItem('tenantName'))
          this.$set(this.goodform, 'businessCompanyName', localStorage.getItem('companyName'))
          this.$set(this.goodform, 'businessCompanyCode', localStorage.getItem('companyCode'))
          return
        }
        this.goodform = res.tWay
        this.goodform.wayId = this.goodform.id
        this.$set(this.goodform, 'wayBusinessType', res.tWay.wayBusinessType.toString())
        this.$set(this.goodform, 'wayState', this.goodform.wayState === 0 ? 1 : this.goodform.wayState)
        this.$set(this.goodform, 'payee', res.tWayBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tWayBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tWayBusiness.payeeCode)
        // delete this.goodform.wayId
        delete this.goodform.id
        delete this.goodform.updateTime
        delete this.goodform.updateUser
        delete this.goodform.updateUserId
        delete this.goodform.orderId
        delete this.goodform.orderNo
        // 删除网货相关的
        delete this.goodform.onlineAddPushFlag
        delete this.goodform.onlineMessage
        delete this.goodform.onlineAddPushTime
        delete this.goodform.onlineUpdatePushFlag
        delete this.goodform.onlineUpdateTimes
        delete this.goodform.onlineUpdatePushTime
        delete this.goodform.auditStatus
        delete this.goodform.onlineOrderNo
        delete this.goodform.freightOnlineFlag

        delete this.goodform.riskControlState
        delete this.goodform.riskControlId
        delete this.goodform.riskControlTime
        delete this.goodform.riskControlRemark
        delete this.goodform.khyNo
        delete this.goodform.generalPeriodDate
        delete this.goodform.periodDate
        delete this.goodform.generalInvoiceDate
        delete this.goodform.imageAbnormalRemark
        delete this.goodform.imageAbnormalState
        // 删除往返单号
        delete this.goodform.roundTripNo
        delete this.goodform.roundTripId

        if (this.goodform.pickupTimeStart) {
          this.$set(this.goodform, 'pickupTime', [this.goodform.pickupTimeStart, this.goodform.pickupTimeEnd])
        }

        if (res.tWay.productType) {
          this.$set(this.goodform, 'productType', res.tWay.productType.toString())
        }
        this.$set(this.goodform, 'kilometres', res.tWay.kilometres ? res.tWay.kilometres.toString() : '0')
        // 附件回显
        res.wayAttachmentsList.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.fileArr.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, name: filename })
        })
        // 收入相关
        this.$set(this.goodform, 'incomePattern', res.tWayBusiness.incomePattern.toString())
        this.$set(this.goodform, 'incomePatternName', res.tWayBusiness.incomePatternName)
        this.$set(this.goodform, 'revenueValuation', res.tWayBusiness.revenueValuation.toString())
        this.$set(this.goodform, 'revenueValuationName', res.tWayBusiness.revenueValuationName)
        this.$set(this.goodform, 'makeTicketYn', res.tWayBusiness.makeTicketYn)
        this.$set(this.goodform, 'ticketSystemYn', res.tWayBusiness.ticketSystemYn)
        if (res.tWayBusiness.incomeUnitPrice) {
          this.$set(this.goodform, 'incomeUnitPrice', res.tWayBusiness.incomeUnitPrice / 100)
        }
        if (res.tWayBusiness.incomeAmount) {
          this.$set(this.goodform, 'incomeAmount', res.tWayBusiness.incomeAmount / 100)
        }

        // 运力收款相关
        this.$set(this.goodform, 'generalCarrier', res.tWayBusiness.generalCarrier)
        this.$set(this.goodform, 'generalTaxId', res.tWayBusiness.generalTaxId)
        this.$set(this.goodform, 'generalCodev', res.tWayBusiness.generalCode)
        this.$set(this.goodform, 'collectionType', res.tWayBusiness.collectionType)
        this.$set(this.goodform, 'payer', res.tWayBusiness.payer)
        this.$set(this.goodform, 'payerTaxId', res.tWayBusiness.payerTaxId)
        if (res.tWayBusiness.expenditurePattern || res.tWayBusiness.expenditurePattern === 0) {
          this.$set(this.goodform, 'expenditurePattern', res.tWayBusiness.expenditurePattern.toString())
          this.$set(this.goodform, 'expenditurePatternName', res.tWayBusiness.expenditurePatternName)
        }
        if (res.tWayBusiness.freightPricingType || res.tWayBusiness.freightPricingType === 0) {
          this.$set(this.goodform, 'freightPricingType', res.tWayBusiness.freightPricingType.toString())
          this.$set(this.goodform, 'freightPricingTypeName', res.tWayBusiness.freightPricingTypeName)
        }
        if (res.tWayBusiness.freightUnitPrice) {
          this.$set(this.goodform, 'freightUnitPrice', res.tWayBusiness.freightUnitPrice / 100)
        }
        if (res.tWayBusiness.freightAmount) {
          this.$set(this.goodform, 'allFreightAmount', res.tWayBusiness.freightAmount / 100)
        }
        this.$set(this.goodform, 'serviceRate', res.tWayBusiness.serviceRate)
        this.$set(this.goodform, 'serviceCharge', res.tWayBusiness.serviceCharge)
        this.$set(this.goodform, 'freightTaxRate', res.tWayBusiness.freightTaxRate)
        this.$set(this.goodform, 'taxRate', res.tWayBusiness.taxRate)
        // 网货信息
        this.$set(this.goodform, 'onlineFreightFlag', Number(res.tWayBusiness.onlineFreightFlag))
        if (res.tWayBusiness.onlineFreightFlag == 1) {
          pushWayToWHPTFlag().then(res => {
            if (res) {
              this.$set(this.goodform, 'WHJKflag', true)
            } else {
              this.$set(this.goodform, 'WHJKflag', false)
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
              }
            })
          })
        }
        this.$set(this.goodform, 'wayState', 1)

        // 清空货物信息
        this.$set(this.goodform, 'goodsList', [])
        this.$set(this.goodform, 'allWeight', '')
        this.$set(this.goodform, 'dispatchWeight', '')
        this.$set(this.goodform, 'dispatchWeightT', '')
        this.$set(this.goodform, 'dispatchVolumn', '')
        this.$set(this.goodform, 'dispatchNumber', '')
        // 清空司机车辆信息
        this.$set(this.goodform, 'plateNumber', '')
        this.$set(this.goodform, 'licensePlateColor', '')
        this.$set(this.goodform, 'licensePlateColorName', '')
        this.$set(this.goodform, 'vehicleType', '')
        this.$set(this.goodform, 'vehicleTypeName', '')
        this.$set(this.goodform, 'energyType', '')
        this.$set(this.goodform, 'energyTypeName', '')
        this.$set(this.goodform, 'driverId', '')
        this.$set(this.goodform, 'driverName', '')
        this.$set(this.goodform, 'driverPhone', '')
        this.$set(this.goodform, 'idNumber', '')
        // 清空凭证相关信息
        this.$set(this.goodform, 'truckload', '')
        this.$set(this.goodform, 'actualLoadingTime', '')
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.$set(this.goodform, 'signedState', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json[0].businessUserCode) {
              this.ywyhFlag = true
            } else {
              this.ywyhFlag = false
            }
            this.goodform.periodDays = json[0].periodDays
            this.goodform.periodDaysType = json[0].periodDaysType
          })
        })
        // 运输类型回显
        this.$set(this.goodform, 'transportMode', this.goodform.transportMode ? this.goodform.transportMode : 1)
        if (this.goodform.transportMode == 2) {
          this.$set(this.goodform, 'activeName', 'second')
        } else {
          this.$set(this.goodform, 'activeName', 'first')
        }
        // 根据货物类型判断吨件方必填 换了一个方法
        // getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => {
        //   // this.HWlist = res
        //   let json = res.filter(item => item.itemNo == this.goodform.productType)
        //   this.goodform.dun = json[0].ext1
        //   this.goodform.jian = json[0].ext2
        //   this.goodform.fang = json[0].ext3
        // })
      })
    } else {
      this.$set(this.goodform, 'taxRate', 9)
      findCustomerInfoList({ businessType: 1 }).then(res => {
        selectTMSTenantListByCustom(res).then(res1 => { this.kehuList = res1 })
      })
      this.$set(this.goodform, 'businessUnit', localStorage.getItem('orgName'))
      this.$set(this.goodform, 'businessUnitCode', localStorage.getItem('orgCode'))
      this.$set(this.goodform, 'businessSubunit', localStorage.getItem('orgSubName'))
      this.$set(this.goodform, 'businessSubunitCode', localStorage.getItem('orgSubCode'))
      this.$set(this.goodform, 'businessTenantCode', localStorage.getItem('tenantCode'))
      this.$set(this.goodform, 'businessTenantName', localStorage.getItem('tenantName'))
      this.$set(this.goodform, 'businessCompanyName', localStorage.getItem('companyName'))
      this.$set(this.goodform, 'businessCompanyCode', localStorage.getItem('companyCode'))
    }
  },
  methods: {
    tagClick (item) {
      this.tagArr.push(item)
      this.tagArr = Array.from(new Set(this.tagArr))
      this.$set(this.goodform, 'remark', this.tagArr.toString())
    },
    remarkFn () {
      if (!this.goodform.remark) {
        this.tagArr = []
      }
    },
    // 卸车时间
    actualUnloadingTimeFn (e) {
      var timestamp1 = new Date(e).getTime()
      let timestamp2 = new Date(this.goodform.actualLoadingTime).getTime()
      if (timestamp1 < timestamp2) {
        this.$alert('卸车时间需要大于装车时间', '系统提示')
        this.$set(this.goodform, 'actualUnloadingTime', null)
      }
    },
    // 签收时间
    actualSigningTimeFn (e) {
      var timestamp1 = new Date(e).getTime()
      let timestamp2 = new Date(this.goodform.actualUnloadingTime).getTime()
      if (timestamp1 < timestamp2) {
        this.$alert('签收时间需要大于卸车时间', '系统提示')
        this.$set(this.goodform, 'actualSigningTime', null)
      }
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
      if (this.oldWayId) { // 往返：根据业务人员信息重新赋值业务部门相关
        this.$set(this.goodform, 'businessUnit', json[0].orgName)
        this.$set(this.goodform, 'businessUnitCode', json[0].orgCode)
        this.$set(this.goodform, 'businessSubunit', json[0].subOrgName)
        this.$set(this.goodform, 'businessSubunitCode', json[0].subOrgCode)
        this.$set(this.goodform, 'businessCompanyName', json[0].subCompanyName)
        this.$set(this.goodform, 'businessCompanyCode', json[0].subCompanyCode)
      }
    },
    // 业务部门更改（往返）
    bumenChange (e) {
      let json = this.bumenList.filter(item => item.code == e)
      if (json.length > 0) {
        this.$set(this.goodform, 'businessUnit', json[0].name)
      }
      // 清空业务部门相关值
      this.$set(this.goodform, 'businessSubunit', null)
      this.$set(this.goodform, 'businessSubunitCode', null)
      this.$set(this.goodform, 'businessCompanyName', null)
      this.$set(this.goodform, 'businessCompanyCode', null)
      // 清空业务人员相关值
      this.$set(this.goodform, 'businessUserId', null)
      this.$set(this.goodform, 'businessUser', null)
      this.yonghuList = []
      if (e) {
        getDepartmentUsers({ orgCode: e, bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
      }
    },
    saveFn (n) {
      const newArr = this.goodform.goodsList.map(item => item.cargoBarcode)
      const arrSet = new Set(newArr)
      if (arrSet.size !== newArr.length) {
        this.$alert('捆包号不能重复', '系统提示')
        return
      }
      if (!this.goodform.kilometres) {
        this.$alert('公里数不能为空，请联系系统管理员', '系统提示')
        return
      }
      if (!this.goodform.allWeight) {
        this.$alert('运单量不能为0', '系统提示')
        return
      }
      if (!this.goodform.deliverAddressId) {
        this.$alert('请选择发货地址', '系统提示')
        return
      }
      if (!this.goodform.receivingAddressId) {
        this.$alert('请选择收货地址', '系统提示')
        return
      }
      if (this.goodform.WHJKflag) {
        if (!this.goodform.idNumber) {
          this.$alert('请选择司机', '系统提示')
          return false
        }
        if (!this.goodform.plateNumber) {
          this.$alert('请选择车辆', '系统提示')
          return false
        }
      } else {
        if (this.goodform.transportMode == 1) {
          if (this.goodform.wayState === 0) {
            if (!this.goodform.driverId) {
              this.$alert('请选择司机', '系统提示')
              return false
            }
            if (!this.goodform.plateNumber) {
              this.$alert('请选择车辆', '系统提示')
              return false
            }
          } else {
            if (!this.goodform.driverId) {
              this.$alert('请选择司机', '系统提示')
              return false
            }
            if (!this.goodform.plateNumber) {
              this.$alert('请选择车辆', '系统提示')
              return false
            }
          }
        }
      }

      if (this.XCimgList.length == 0 && this.goodform.wayState >= 3) {
        this.$alert('请选择卸车凭证', '系统提示')
        return false
      }

      if (this.goodform.liquidatedAmount === 0) {
        this.$alert('结算量不能为0', '系统提示')
        return false
      }
      if (this.goodform.plateNumber && this.goodform.wayState == 1) { // 根据有没用车牌号来判断是待配载还是待装车
        this.$set(this.goodform, 'wayState', 1)
      } else if (this.goodform.wayState == 1) {
        this.$set(this.goodform, 'wayState', 0)
      }
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.wayBusinessType)
      if (yewuleixingJson.length > 0) {
        this.goodform.wayBusinessTypeName = yewuleixingJson[0].showName
      } else {
        this.$set(this.goodform, 'wayBusinessType', null)
      }

      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.goodform.pickupTime) {
            this.goodform.pickupTimeStart = this.goodform.pickupTime[0]
            this.goodform.pickupTimeEnd = this.goodform.pickupTime[1]
          }
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json.length > 0) {
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.payeeCode = json[0].tenantCode
          }

          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
          }

          // 赋值调度量
          this.$set(this.goodform, 'dispatchWeight', this.goodform.allWeight)
          // 运费总额赋值
          this.$set(this.goodform, 'freightAmount', this.goodform.allFreightAmount)
          // 后端让写的，为了兼容小程序
          this.$set(this.goodform, 'addWayUrls', [])
          this.$set(this.goodform, 'addWayUrlst', [])
          this.$set(this.goodform, 'addWayUrlsu', [])
          this.$set(this.goodform, 'addWayUrlss', [])
          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(this.goodform))
          this.fileArr.forEach(item => {
            imgfile.append('files', item.raw)
          })
          this.ZCimgList.forEach(item => {
            imgfile.append('loadFiles', item.raw)
          })
          this.XCimgList.forEach(item => {
            imgfile.append('unLoadFiles', item.raw)
          })
          this.QSimgList.forEach(item => {
            imgfile.append('signFiles', item.raw)
          })
          addWay(imgfile).then(res => {
            loading.close()
            if (n == 1) {
              this.$emit('update:addFlag', false)
              this.$emit('updateCreateTimes')
              this.$parent.searchFn()
            } else if (n == 3) {
              this.$emit('update:addFlag', false)
              this.$emit('updateCreateTimes')
              this.$parent.searchFn()
              this.$router.push({ path: '/tmsWayDayin', query: { ids: res } })
            } else {
              this.$set(this.goodform, 'goodsList', [])
              this.$set(this.goodform, 'allWeight', '')
              this.$set(this.goodform, 'dispatchWeight', '')
              this.$set(this.goodform, 'dispatchWeightT', '')
              this.$set(this.goodform, 'dispatchVolumn', '')
              this.$set(this.goodform, 'dispatchNumber', '')
              // 清空司机车辆信息
              this.$set(this.goodform, 'plateNumber', '')
              this.$set(this.goodform, 'licensePlateColor', '')
              this.$set(this.goodform, 'vehicleType', '')
              this.$set(this.goodform, 'vehicleTypeName', '')
              this.$set(this.goodform, 'energyType', '')
              this.$set(this.goodform, 'energyTypeName', '')
              this.$set(this.goodform, 'driverId', '')
              this.$set(this.goodform, 'driverName', '')
              this.$set(this.goodform, 'driverPhone', '')
              this.$set(this.goodform, 'idNumber', '')
              // 清空凭证相关信息
              this.$set(this.goodform, 'truckload', '')
              this.$set(this.goodform, 'actualLoadingTime', '')
              this.$set(this.goodform, 'unloadings', '')
              this.$set(this.goodform, 'actualUnloadingTime', '')
              this.$set(this.goodform, 'receiptRequest', '')
              this.$set(this.goodform, 'signRemark', '')
              this.$set(this.goodform, 'liquidatedAmount', '')
              this.$set(this.goodform, 'actualSigningTime', '')

              this.fileArr = []
              this.loadFiles = []
              this.unLoadFiles = []
              this.signFiles = []
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 运单状态改变
    wayStateChange (e) {
      if (e == 1) {
        this.$set(this.goodform, 'truckload', '')
        this.$set(this.goodform, 'actualLoadingTime', '')
        this.ZCimgList = []
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 2) {
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 3) {
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 4) {
        this.$set(this.goodform, 'signedState', 0)
        this.$set(this.goodform, 'actualSigningTime', new Date().getTime())
        this.$set(this.goodform, 'liquidatedAmount', this.goodform.allWeight)
        this.$set(this.goodform, 'actualSigningPerson', localStorage.getItem('userName'))
      }
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payCustomerId = json[0].id
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.payeeCode = json[0].tenantCode
      this.goodform.salesContract = ''
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }
      this.goodform.originalCustomer = this.goodform.payee// 下单客户
    },
    xuanzeHT () {
      if (this.goodform.payee) {
        let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
        this.goodform.payCustomerId = json[0].id
        this.GLHTflag = true
      } else {
        this.$alert('请先选择结算客户', '系统提示')
      }
    },
    delGoodFn () {
    },
    closeDialog () {
      this.$emit('update:addFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.remark .el-input .el-input__inner{
  width: 800px;
  height: 80px;
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
.width1  /deep/.el-input__inner{
  width:100px;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}
.imgBox{
  margin: 0px 15px  10px;
}
/deep/.el-range-editor{
  width: 430px;
}
</style>
